import{Locale as e}from"../Locale.js";const r=(r={})=>new Map(Object.entries(r).map((([r,t])=>[e[r],t]))),t=(e,r,t="")=>{var o;return null!==(o=e.get(r))&&void 0!==o?o:t};export{r as l10nText,t as trans};
//# sourceMappingURL=index.js.map
